const BUCKET_NAME = 'metadata.photo_url';

export default class ThingPictureController {
    /** @ngInject */
    constructor(EventEmitter) {
        this.eventEmitter = EventEmitter;
    }

    $onInit() {
        this.thingPicture = false;
    }

    $onChanges(changes) {
        if (changes.reset) {
            if (!changes.reset.isFirstChange() && changes.reset.currentValue === true) {
                this.resetValues();
            }
        }
    }

    onChange() {
        if (this.thingPicture) {
            this.fillBucket();

            this.pushUpdate(
                this.eventEmitter({
                    value: this.thingPicture
                })
            );
        } else {
            this.clearBucket();
        }
    }

    fillBucket() {
        this.addItemToBucket(
            this.eventEmitter({
                item: {
                    name: BUCKET_NAME,
                    value: this.thingPicture
                }
            })
        );
    }

    clearBucket() {
        this.removeItemFromBucket(
            this.eventEmitter({
                item: {
                    name: BUCKET_NAME
                }
            })
        );
    }

    resetValues() {
        this.thingPicture = false;

        this.clearBucket();
    }
}



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/search/advanced/thing-picture/thing-picture.controller.js